import { useEffect } from "preact/hooks";

export function useMountEffect(effect: () => void | (() => void)) {
  // eslint-disable-next-line react-hooks/exhaustive-deps, no-restricted-syntax
  useEffect(effect, []);
}
